// ✅ US Market Growth Engines - Thin Wrapper (DRY principle)
import GrowthEnginesPage from '../growth-engines';
import SEOHead from '../../components/SEOHead';

export default function USGrowthEnginesPage() {
  return (
    <>
      <SEOHead
        title='All-in-One Growth Engines for Scaling US Businesses | LBVisible'
        description='High-ROI digital engines: Web Dev, Technical SEO, and GBP Ranking in one closed-loop system. Dominate local search and scale your US business.'
        keywords='growth engines USA, web development agency USA, SEO agency USA, digital marketing USA'
        canonicalUrl='/us/growth-engines'
        lang='en'
        hreflang={[
          { hreflang: 'en-GB', href: 'https://www.lbvisible.com/growth-engines' },
          { hreflang: 'en-US', href: 'https://www.lbvisible.com/us/growth-engines' },
          { hreflang: 'lt-LT', href: 'https://www.lbvisible.com/lt/augimo-varikliai' },
          { hreflang: 'x-default', href: 'https://www.lbvisible.com/growth-engines' },
        ]}
      />

      {/* Reuse the main GrowthEngines component - single source of truth for design */}
      <GrowthEnginesPage />
    </>
  );
}
